import { FC, PropsWithChildren } from 'react'

import { useUser } from 'containers/App'
import { AccessDeniedWidget } from 'components/AccessDeniedWidget'

type Props = PropsWithChildren<{
  permissions: string[]
}>

export const PermissionBoundary: FC<Props> = props => {
  const { permissions, children } = props

  const { hasPermissions } = useUser()

  return hasPermissions(permissions) ? <>{children}</> : <AccessDeniedWidget />
}
